import { useState, useEffect } from 'react';
import { fullstoryEvent, FSProperties } from '@/fullstory/utils/fullstory-event';

/**
 * Sends an event to Fullstory when a provided "unlock condition" is met, once per page.
 *
 * @param unlockCondition - The condition that must be met to send the event to Fullstory
 * @param eventName - The name of the event to send to Fullstory, event will not send if falsy (optional)
 * @param properties - The properties to send with the event (optional)
 */
export const useFullstorySendEventOnce = (
  unlockCondition: boolean,
  eventName?: string,
  properties?: FSProperties
) => {
  const [hasSent, setHasSent] = useState(false);

  useEffect(() => {
    if (
      unlockCondition === true &&
      eventName &&
      // The first couple of renders after modal completion, modal contents may not have reached session cart yet, so we wait
      !hasSent
    ) {
      fullstoryEvent(eventName, properties || {});
      setHasSent(true);
    }
  }, [unlockCondition, eventName, properties, hasSent]);
};
